<app-breadcrumbs [headerTitle]="'BANK FIELDS'" />
<div class="main-container">
	<app-country-select></app-country-select>
	<app-bank-account-fields></app-bank-account-fields>
</div>
